import { Component, DestroyRef, inject, input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ThemeService } from '@core/services/theme.service';
import { TranslateModule } from '@ngx-translate/core';
import { Icon } from '@shared/components/icon/icon.enum';
import { ButtonComponent } from '../../../shared/components/button/button.component';

@Component({
  selector: 'app-topbar',
  imports: [ButtonComponent, TranslateModule],
  templateUrl: './topbar.component.html',
  styleUrl: './topbar.component.scss',
})
export class TopbarComponent {
  private destroyRef = inject(DestroyRef);

  Icon = Icon;
  logo?: string;
  highContrast = false;
  hasTheme = false;

  hasLanguage = input(false);

  constructor(private themeService: ThemeService) {
    // Subscribe once (avoid creating nested subscriptions on every theme update)
    this.themeService.hasTheme
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((hasTheme) => {
        this.hasTheme = hasTheme;
      });

    this.themeService
      .getTheme()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((theme) => {
        // Always recompute logo and explicitly clear it when missing/empty
        // (e.g., if you remove it in theme manager)
        const mediaUrl = theme?.parameters?.logoUrl?.mediaUrl;
        const baseUrl = theme?.parameters?.logoUrl?.baseUrl ?? '';

        this.logo = mediaUrl?.length ? `${baseUrl}${mediaUrl}` : undefined;

        this.highContrast = this.themeService.highContrast;
      });
  }

  toggleHighContrast(): void {
    this.themeService.toggleHighContrast();
    this.highContrast = this.themeService.highContrast;
  }
}
